/** @jsx jsx */
import { graphql, useStaticQuery } from 'gatsby';
import { gql } from 'urql';
import CardBlockFragment from '../../../../components/Blocks/CardBlockFragment';
import IconBlockFragment from '../../../../components/Blocks/IconBlockFragment';
import ImageBlockFragment from '../../../../components/Blocks/ImageBlockFragment';
import MenuItemBlockFragment from '../../../../components/Blocks/MenuItemBlockFragment';
import SocialMediaBlockFragment from '../../../../components/Blocks/SocialMediaBlockFragment';
import TextBlockFragment from '../../../../components/Blocks/TextBlockFragment';
import TitleBlockFragment from '../../../../components/Blocks/TitleBlockFragment';
import VideoBlockFragment from '../../../../components/Blocks/VideoBlockFragment';
import usePreviewData from '../../../../usePreviewData';

// The CMS is almost always active, but pointing to a collection without any data
// Therefore we use the baseMenuQuery to fall back to the event data.
export default function useFooterQuery({ locale }) {
  const result = useStaticQuery(query);
  const collectionId = result?.collection?.collectionId;
  const sites = result?.allSanitySite?.nodes;
  const site = sites?.find((site) => site.collectionId === collectionId);

  // We want to use preview data if available
  // At the moment, we are only loading published data, not draft data
  const [previewData] = usePreviewData();

  return previewData?.data?.site?.[0]?.footer || site?.footer;
}

const query = graphql`
  {
    collection: event {
      collectionId: eventId
    }
    allSanitySite {
      nodes {
        collectionId
        footer {
          ... on SanityGridColumnBlock {
            _key
            ...SanityGridColumnBlockFragment
            style {
              ...BlockStyle
            }
          }
          ...BlocksFragment
        }
      }
    }
  }
`;

export const useFooterQueryFragment = gql`
  fragment useFooterQueryFragment on Site {
    collectionId
    footer {
      ... on CardBlock {
        _key
        ...CardBlockFragment
      }

      ... on IconBlock {
        _key
        ...IconBlockFragment
      }
      ... on ImageBlock {
        _key
        ...ImageBlockFragment
      }
      ... on MenuItemBlock {
        _key
        ...MenuItemBlockFragment
      }
      ... on SocialMediaBlock {
        _key
        ...SocialMediaBlockFragment
      }
      ... on TextBlock {
        _key
        ...TextBlockFragment
      }
      ... on TitleBlock {
        _key
        ...TitleBlockFragment
      }
      ... on VideoBlock {
        _key
        ...VideoBlockFragment
      }
    }
  }
  ${CardBlockFragment}
  ${IconBlockFragment}
  ${MenuItemBlockFragment}
  ${SocialMediaBlockFragment}
  ${TextBlockFragment}
  ${TitleBlockFragment}
  ${ImageBlockFragment}
  ${VideoBlockFragment}
`;
